"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminRefundRequestDto = exports.AdminRefundRequestTicketDto = exports.AdminRefundRequestUserDto = exports.RefundRequestSummaryDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
/**
 * A refund request as the user (ticket list) and the feedback thread see it. Embedded in
 * UserTicketDto.refundRequest and CommentDto.refundRequest.
 */
class RefundRequestSummaryDto {}
exports.RefundRequestSummaryDto = RefundRequestSummaryDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], RefundRequestSummaryDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], RefundRequestSummaryDto.prototype, "ticketPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.RefundRequestStatus
}), __metadata("design:type", String)], RefundRequestSummaryDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Amount to refund in cents (USD): what was still refundable when requested.'
}), __metadata("design:type", Number)], RefundRequestSummaryDto.prototype, "amountCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Event the ticket is for (snapshot at request time).'
}), __metadata("design:type", String)], RefundRequestSummaryDto.prototype, "eventName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Feedback topic where the refund is discussed.'
}), __metadata("design:type", String)], RefundRequestSummaryDto.prototype, "commentPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Admin note sent with the approval / decline.'
}), __metadata("design:type", Object)], RefundRequestSummaryDto.prototype, "decisionNote", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], RefundRequestSummaryDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], RefundRequestSummaryDto.prototype, "reviewedAt", void 0);
class AdminRefundRequestUserDto {}
exports.AdminRefundRequestUserDto = AdminRefundRequestUserDto;
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestUserDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestUserDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestUserDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestUserDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestUserDto.prototype, "telephone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestUserDto.prototype, "imageUrl", void 0);
/** What was bought — everything an admin needs to judge the refund. */
class AdminRefundRequestTicketDto {}
exports.AdminRefundRequestTicketDto = AdminRefundRequestTicketDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestTicketDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.TicketStatus
}), __metadata("design:type", String)], AdminRefundRequestTicketDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminRefundRequestTicketDto.prototype, "quantity", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Unit price in cents (USD).'
}), __metadata("design:type", Number)], AdminRefundRequestTicketDto.prototype, "priceCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Amount charged in cents (USD).'
}), __metadata("design:type", Number)], AdminRefundRequestTicketDto.prototype, "totalCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Amount refunded so far in cents (USD).'
}), __metadata("design:type", Number)], AdminRefundRequestTicketDto.prototype, "refundedCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestTicketDto.prototype, "cardBrand", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestTicketDto.prototype, "cardLast4", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestTicketDto.prototype, "receiptUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestTicketDto.prototype, "squarePaymentId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestTicketDto.prototype, "purchasedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestTicketDto.prototype, "eventPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestTicketDto.prototype, "eventName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestTicketDto.prototype, "eventStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestTicketDto.prototype, "eventEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestTicketDto.prototype, "venueName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestTicketDto.prototype, "venueAddress", void 0);
class AdminRefundRequestDto {}
exports.AdminRefundRequestDto = AdminRefundRequestDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.RefundRequestStatus
}), __metadata("design:type", String)], AdminRefundRequestDto.prototype, "status", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: "The user's reason."
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "reason", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Amount to refund in cents (USD).'
}), __metadata("design:type", Number)], AdminRefundRequestDto.prototype, "amountCents", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "decisionNote", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "reviewedByName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "reviewedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Square refund ID — look it up in the Square Dashboard.'
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "squareRefundId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Square Refund.status: PENDING, COMPLETED, REJECTED or FAILED.'
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "squareRefundStatus", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Square error code of the last failed refund attempt.'
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "failureCode", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestDto.prototype, "commentPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'When the feedback topic was closed, if it was.'
}), __metadata("design:type", Object)], AdminRefundRequestDto.prototype, "commentClosedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminRefundRequestDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminRefundRequestUserDto
}), __metadata("design:type", AdminRefundRequestUserDto)], AdminRefundRequestDto.prototype, "user", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminRefundRequestTicketDto
}), __metadata("design:type", AdminRefundRequestTicketDto)], AdminRefundRequestDto.prototype, "ticket", void 0);
//# sourceMappingURL=RefundRequest.dto.js.map